import {
  DISPATCH_VIEW,
  SALES_VIEW,
  SD_VIEW,
  FINANCE_VIEW,
  HIDE_FRANCHISE,
} from 'actions/bookingsListToggles'

const INITIAL_STATE = {
  salesView: false,
  sdView: false,
  dispatchView: false,
  financeView: false,
  hideFranchise: false,
}

export default (state = INITIAL_STATE, action) => {
  const asArray = action.type?.split('_') || []
  const adjustFormat =
    asArray.length > 1
      ? asArray[0].toLowerCase() +
        asArray[1].charAt(0) +
        asArray[1].slice(1).toLowerCase()
      : asArray[0]?.toLowerCase() || ''
  if (!(adjustFormat in state)) return state // ignore unknown actions
  switch (action.type) {
    case SD_VIEW:
      return {
        ...INITIAL_STATE,
        hideFranchise: false,
        sdView: !state.sdView,
      }
    case SALES_VIEW:
      return {
        ...INITIAL_STATE,
        hideFranchise: false,
        salesView: !state.salesView,
      }
    case DISPATCH_VIEW:
      return {
        ...INITIAL_STATE,
        hideFranchise: false,
        dispatchView: !state.dispatchView,
      }
    case FINANCE_VIEW:
      return {
        ...INITIAL_STATE,
        hideFranchise: false,
        financeView: !state.financeView,
      }
    case HIDE_FRANCHISE:
      return {
        ...state,
        hideFranchise: state.dispatchView ? !state.hideFranchise : false,
      }
    default:
      return state
  }
}
